import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'fury-loading-overlay',
  templateUrl: './loading-overlay.component.html',
  styleUrls: ['./loading-overlay.component.scss']
})
export class LoadingOverlayComponent implements OnInit {

  @Input() isLoading: boolean;
  @Input() fill: boolean = false;
  @Input() top: boolean = false;
  @Input() uploadProgress: number = null;

  constructor() {
  }

  ngOnInit() {
  }

}
